const routes = [
  {
    path: '/',
    component: () => import('@/layouts/Master.vue'),
    children: [
      {
        path: '',
        component: () => import('@/layouts/Private.vue'),
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            component: () => import('@/modules/overview/pages/Overview.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: '/dashboard',
            component: () => import('@/modules/dashboard/pages/DashboardConfig.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/teams',
            component: () => import('@/pages/Organization/Teams/List.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/users',
            component: () => import('@/pages/Organization/Users/List.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/milestones',
            component: () => import('@/pages/Organization/Milestones/Milestones.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/metadata',
            component: () => import('@/pages/Organization/Metadata/List.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/financial',
            component: () => import('@/pages/Organization/Financial/Financial.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/financial/extract',
            component: () => import('@/pages/Organization/Financial/Extract.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/financial/plan',
            component: () => import('@/pages/Organization/Financial/Plan.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'surveys',
            component: () => import('@/pages/Surveys/List/Surveys.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'surveys/create/:uuid?',
            component: () => import('@/pages/Surveys/Create/Create.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'surveys/:uuid/report',
            component: () => import('@/pages/Surveys/Report/Report.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'customers',
            component: () => import('@/pages/Customers/Customers.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'interactions/:segment_uuid?',
            component: () => import('@/modules/interaction/pages/InteractionPage.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'profile',
            component: () => import('@/pages/Profile/ProfileData.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/logs',
            component: () => import('@/pages/Organization/Logs.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/blockrules',
            component: () => import('@/pages/Organization/Blockrules/List.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/blockrules/affected/:uuid',
            component: () => import('@/pages/Organization/Blockrules/CustomerAffected.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/settings',
            component: () => import('@/pages/Organization/Organization/Settings.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'surveys/:uuid/distribution/create',
            component: () => import('@/pages/Surveys/Distribution/Create/NewDistribution.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'surveys/:uuid/distributions',
            component: () => import('@/pages/Surveys/Distribution/Distributions.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'surveys/:uuid/distributions-new',
            component: () => import('@/modules/survey-distributions/pages/SurveyDistributions.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'surveys/:uuid/distributions/:distribution_uuid/customers',
            component: () => import('@/pages/Surveys/Distribution/Customers.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/categories',
            component: () => import('@/pages/Organization/Categories/List.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/iprestriction',
            component: () => import('@/pages/Organization/IPRestriction.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'dashboard/library',
            component: () => import('@/pages/Dashboard/Library.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/domain',
            component: () => import('@/pages/Organization/Domain/Domain.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/sso',
            component: () => import('@/pages/Organization/SSO/SSO.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/widget',
            component: () => import('@/pages/Organization/Widget/List.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/widget/create/:uuid?',
            component: () => import('@/pages/Organization/Widget/Create/Create.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/integrations',
            component: () => import('@/pages/Organization/Integrations/Integrations.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/integrations/add',
            component: () => import('@/pages/Organization/Integrations/AddIntegration.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/integrations/sftp/:uuid?',
            component: () => import('@/pages/Organization/Integrations/SFTP.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/integrations/webhook/:uuid?',
            component: () => import('@/pages/Organization/Integrations/Webhook.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/integrations/api/:uuid?',
            component: () => import('@/pages/Organization/Integrations/API.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/integrations/zendesk/:uuid?',
            component: () => import('@/pages/Organization/Integrations/Zendesk.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/integrations/whatsapp/:uuid?',
            component: () => import('@/pages/Organization/Integrations/Whatsapp.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'loops',
            component: () => import('@/pages/Loops/Loops.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'loops/new',
            component: () => import('@/pages/Loops/Create/Create.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'loops/:uuid',
            component: () => import('@/pages/Loops/Create/Create.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'loops/:uuid/dealts',
            component: () => import('@/pages/Loops/Dealts/Dealts.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'loops/:uuid/dealts/:dealtUUID',
            component: () => import('@/pages/Loops/Dealts/Update/Update.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/templates',
            component: () => import('@/pages/Organization/Templates/List.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/templates/new',
            component: () => import('@/pages/Organization/Templates/Create/Create.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
          {
            path: 'organization/templates/:uuid',
            component: () => import('@/pages/Organization/Templates/Create/Create.vue'),
            meta: { requiresAuth: true, requiresOrganization: true },
          },
        ],
      },
      {
        path: '',
        component: () => import('@/layouts/Public.vue'),
        children: [
          { path: 'login', component: () => import('@/pages/Login.vue') },
          { path: 'finish-registration/:token', component: () => import('@/pages/FinishRegistration.vue') },
          { path: 'reset-password/:token', component: () => import('@/pages/PasswordReset.vue') },
          { path: 'password-recovery', component: () => import('@/pages/PasswordRecovery.vue') },
          { path: 'saml-login/:token', component: () => import('@/pages/SSO.vue') },
          {
            name: 'SelectOrganization',
            path: 'organization/select',
            component: () => import('@/pages/Organization/Organization/Select.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'organization/select/:orgUUID/admin',
            component: () => import('@/pages/Organization/Organization/Select.vue'),
            meta: { requiresAuth: true },
          },
        ],
      },
      {
        path: 'organization/create',
        component: () => import('@/pages/Organization/Organization/Create/Create.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Dashboard Live',
        path: 'dashboard/live/:dashboard_hash',
        component: () => import('@/modules/dashboard/pages/DashboardLive.vue'),
      },
      {
        path: 'survey/:token',
        component: () => import('@/pages/Surveys/Web/Survey.vue'),
      },
      {
        path: 'unsubscribe/:organization_uuid/:customer_uuid/:distribution_uuid',
        component: () => import('@/pages/Unsubscribe.vue'),
      },
      {
        path: 'surveys/download/:organization_uuid/:survey_uuid/:distribution_uuid',
        component: () => import('@/pages/Surveys/Distribution/DownloadLinkList.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'download/:organization_uuid/:download_uuid',
        component: () => import('@/pages/Download.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'organization/widget/documentation',
        component: () => import('@/pages/Organization/Widget/Documentation.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },
];

routes.push({
  path: '*',
  component: () => import('@/pages/Error404.vue'),
});

export default routes;
